import type {StackProps} from '@mui/material/Stack';
import type {FC} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {mergeSlotProps} from '@mui/material/utils';

interface LoadingMessageProps {
  title?: string;
  message?: string;
  progressSize?: number;
  rootProps?: StackProps;
}

const LoadingMessage: FC<LoadingMessageProps> = ({
  title = 'Loading',
  message = 'One moment please',
  progressSize = 50,
  rootProps = {},
}) => (
  <Stack
    data-testid="loading-message"
    {...mergeSlotProps<StackProps>(rootProps, {
      sx: {
        alignItems: 'center',
        flexShrink: 0,
        justifyContent: 'center',
        margin: 'auto',
        textAlign: 'center',
      },
    })}
  >
    <CircularProgress
      aria-label={title}
      color="primary"
      size={progressSize}
      sx={{marginBottom: 2}}
    />
    {title && (
      <Typography gutterBottom variant="h5" sx={{color: 'text.secondary'}}>
        {title}
      </Typography>
    )}
    {message && (
      <Typography variant="h6" sx={{color: 'text.secondary'}}>
        {message}
      </Typography>
    )}
  </Stack>
);

export default LoadingMessage;
